// This file is auto-generated by @hey-api/openapi-ts

import { formDataBodySerializer } from './client';
import { client } from './Client.gen';
import type { EshopCustomerProfileApplicationControllerCreateData } from './EshopCustomerProfileApplicationControllerCreateData.gen';
import type { EshopCustomerProfileApplicationControllerCreateErrors } from './EshopCustomerProfileApplicationControllerCreateErrors.gen';
import type { EshopCustomerProfileApplicationControllerCreateResponses } from './EshopCustomerProfileApplicationControllerCreateResponses.gen';
import type { EshopCustomerProfileApplicationControllerGetOneData } from './EshopCustomerProfileApplicationControllerGetOneData.gen';
import type { EshopCustomerProfileApplicationControllerGetOneErrors } from './EshopCustomerProfileApplicationControllerGetOneErrors.gen';
import type { EshopCustomerProfileApplicationControllerGetOneResponses } from './EshopCustomerProfileApplicationControllerGetOneResponses.gen';
import type { EshopCustomerProfileApplicationControllerGetUnprocessedCountData } from './EshopCustomerProfileApplicationControllerGetUnprocessedCountData.gen';
import type { EshopCustomerProfileApplicationControllerGetUnprocessedCountErrors } from './EshopCustomerProfileApplicationControllerGetUnprocessedCountErrors.gen';
import type { EshopCustomerProfileApplicationControllerGetUnprocessedCountResponses } from './EshopCustomerProfileApplicationControllerGetUnprocessedCountResponses.gen';
import type { EshopCustomerProfileApplicationControllerUploadAttachmentData } from './EshopCustomerProfileApplicationControllerUploadAttachmentData.gen';
import type { EshopCustomerProfileApplicationControllerUploadAttachmentErrors } from './EshopCustomerProfileApplicationControllerUploadAttachmentErrors.gen';
import type { EshopCustomerProfileApplicationControllerUploadAttachmentResponses } from './EshopCustomerProfileApplicationControllerUploadAttachmentResponses.gen';
import type { Options } from './Options.gen';

export class EshopCustomerProfileApplicationController {
    /**
     * Get customer profile application.
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<EshopCustomerProfileApplicationControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerProfileApplicationControllerGetOneResponses, EshopCustomerProfileApplicationControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-profile-applications/{id}',
            ...options
        });
    }
    
    /**
     * Get unprocessed count of customer profile applications.
     */
    public static getUnprocessedCount<ThrowOnError extends boolean = false>(options: Options<EshopCustomerProfileApplicationControllerGetUnprocessedCountData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerProfileApplicationControllerGetUnprocessedCountResponses, EshopCustomerProfileApplicationControllerGetUnprocessedCountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-profile-applications/{id}/unprocessed-count',
            ...options
        });
    }
    
    /**
     * Create customer profile application.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.<br>
     * + **INVALID_PROFILE_VALID_FROM** - Profile ValidFrom is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_PROFILE_VALID_TO** - Profile ValidTo is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_PROFILE_VALIDITY** - Customer profile does not exist or is not in card validFrom-validTo range.<br>
     * + **CUSTOMER_PROFILES_COLLISION** - Customer profiles validFrom-validTo ranges are in collision.<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.<br>
     * + **CUSTOMER_PROFILE_APPLICATION_IS_NOT_ALLOWED** - Customer profile application is not allowed in system configuration<br>
     * + **INVALID_CARD_STATE** - Card state does not exist or is invalid.<br>
     * + **CUSTOMER_PROFILE_APPLICATION_NOT_ALLOWED_FOR_HAULIER_CARD** - Customer profile application is not allowed for haulier card.<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CUSTOMER_PROFILE_APPLICATION** - Customer already has active customer profile application.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<EshopCustomerProfileApplicationControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerProfileApplicationControllerCreateResponses, EshopCustomerProfileApplicationControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-profile-applications',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add attachment to profile application.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static uploadAttachment<ThrowOnError extends boolean = false>(options: Options<EshopCustomerProfileApplicationControllerUploadAttachmentData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerProfileApplicationControllerUploadAttachmentResponses, EshopCustomerProfileApplicationControllerUploadAttachmentErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-profile-applications/{id}/attachment',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}
